// @ts-expect-error
import Markdown from 'markdown-it'

export function useMarkdown<T>(markdown: string | null ): string {
  // No input, no output
  if (!markdown) return ''

  // Initialize markdown renderer
  const md = new Markdown()

  // Render
  const html = md.render(markdown)
  return `<span class="hy-markdown">${html}</span>`
}
